import type { Timestamp } from 'firebase/firestore';

export const FEEDBACK_POST_TYPES = [
  'hook',
  'caption',
  'content_idea',
  'profile',
  'general',
] as const;

export type FeedbackPostType = (typeof FEEDBACK_POST_TYPES)[number];

export const FEEDBACK_PLATFORMS = [
  'tiktok',
  'instagram',
  'youtube',
  'other',
] as const;

export type FeedbackPlatform = (typeof FEEDBACK_PLATFORMS)[number];

export type FeedbackPostStatus = 'open' | 'closed';

export const FEEDBACK_POSTS_COLLECTION = 'feedbackPosts';
export const FEEDBACK_COMMENTS_SUBCOLLECTION = 'comments';

export interface FeedbackPost {
  id: string;
  authorId: string;
  authorUsername: string;
  authorDisplayName: string;
  authorPhotoURL: string | null;
  role: 'creator';
  feedbackType: FeedbackPostType;
  platform: FeedbackPlatform;
  title: string;
  description: string;
  contentUrl: string | null;
  feedbackPrompt: string | null;
  status: FeedbackPostStatus;
  commentCount: number;
  participantCount: number;
  participantUserIds: string[];
  lastActivityAt: Timestamp | null;
  createdAt: Timestamp | null;
  updatedAt: Timestamp | null;
  tags: string[];
  solvedCommentId: string | null;
  isEdited: boolean;
}

export interface FeedbackComment {
  id: string;
  authorId: string;
  authorUsername: string;
  authorDisplayName: string;
  authorPhotoURL: string | null;
  body: string;
  createdAt: Timestamp | null;
  updatedAt: Timestamp | null;
  isEdited: boolean;
}

export interface AuthorSnapshot {
  authorId: string;
  authorUsername: string;
  authorDisplayName: string;
  authorPhotoURL: string | null;
}
